import React from "react";
import {LIGHT_TEXT_COLOR} from "../common/styles";

const clearFixStyles = {overflow: "auto"};

const Header = ({firstName, lastName, jobRole, companyName, regulatingAuthority, email}) => (
    <header style={{...clearFixStyles, marginBottom: "20px", padding: "20px"}}>
        <div style={{float:"right"}}>
            <div style={{textAlign:"right", float: "right", marginTop: "0.5em"}}>
                <span className="x-author-fullname" style={{fontWeight: "bold", fontSize: "130%"}}>{firstName} {lastName}</span><br/>
                <span className="x-author-email" style={{color: LIGHT_TEXT_COLOR}}>
                        <a style={{color: LIGHT_TEXT_COLOR}} href={`mailto:${email}`}>{email}</a><br/>
                    </span>
                <span className="x-author-job-role" style={{color: LIGHT_TEXT_COLOR, fontSize: "80%"}}>{jobRole}</span><br/>
                <span className="x-author-company" style={{color: LIGHT_TEXT_COLOR, fontSize: "80%"}}>{companyName}</span><br/>
                {regulatingAuthority ? <span className="x-author-regulator" style={{color: LIGHT_TEXT_COLOR, fontSize: "80%"}}>{firstName} {lastName} is regulated by the {regulatingAuthority}</span> : null}
            </div>
        </div>
    </header>
);

Header.propTypes = {
    firstName: React.PropTypes.string,
    lastName: React.PropTypes.string,
    jobRole: React.PropTypes.string,
    email: React.PropTypes.string,
    companyName: React.PropTypes.string,
    regulatingAuthority: React.PropTypes.string
};

export default Header;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/components/Header.js
 **/